export function getPrintsLabel(count: number): string {
  const mod100 = count % 100
  const mod10 = count % 10

  if (count === 1) {
    return `Twój ulubiony raport`
  } else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
    return `Twoje ulubione raporty`
  } else {
    return `Twoich ulubionych raportów`
  }
}

export function getCopiesLabel(count: number): string {
  const mod100 = count % 100
  const mod10 = count % 10

  if (count === 1) {
    return `kopia`
  } else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
    return `kopie`
  } else {
    return `kopii`
  }
}